/**
 * Paving Page Critical JavaScript
 * Loads immediately for essential paving page functionality
 * Isotope filters and Fancybox gallery are lazy-loaded
 */

import { lazyLoader } from './utils/lazy-loader.js';

(function() {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    // Lazy-load Isotope after images are ready (on window load)
    if (document.querySelector('[data-isotope]')) {
      window.addEventListener('load', () => {
        import('./modules/isotope-module.js').then(module => {
          module.initIsotope();
        });
      });
    }

    // Set up lazy Fancybox - loads on first image click
    if (document.querySelector('[data-fancybox]')) {
      import('./modules/fancybox-module.js').then(module => {
        module.setupLazyFancybox();
      });
    }

    // Lazy-load Flickity for product carousels when visible
    if (document.querySelector('[data-flickity]')) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            import('./modules/flickity-module.js').then(module => {
              module.initFlickity();
            });
            observer.disconnect();
          }
        });
      }, { rootMargin: '100px' });

      document.querySelectorAll('[data-flickity]').forEach(carousel => {
        observer.observe(carousel);
      });
    }

    // Lazy-load animations after page load
    window.addEventListener('load', () => {
      setTimeout(() => {
        import('./modules/animations-module.js').then(module => {
          module.initAnimations();
        });
      }, 1500);
    });
  });
})();
